"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";

export default function SaasFooter({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const links = content.links || ["Privacy", "Terms", "Status", "Contact"];

  return (
    <footer
      className={`py-12 bg-slate-950 text-slate-500 text-xs border-t border-slate-900 transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="space-y-1 text-center md:text-left">
          <h3 className="text-sm font-bold text-white">
            <EditableText
              value={content.companyName || "SaaS Co."}
              onChange={(val) => onContentChange?.({ ...content, companyName: val })}
              as="span"
            />
          </h3>
          <p>
            <EditableText
              value={content.copyright || "© 2026 Instacks. All rights reserved."}
              onChange={(val) => onContentChange?.({ ...content, copyright: val })}
              as="span"
            />
          </p>
        </div>

        <div className="flex gap-6">
          {links.map((link: string, idx: number) => (
            <a key={idx} href={`#${link.toLowerCase()}`} className="hover:text-white transition-colors">
              {link}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
